export enum DownloadStatus {
    None = 1,
    Downloading = 2,
    Completed = 3
}
